import React, {useState} from 'react';
import ReactDOM from "react-dom";
import Modal, {ModalBody, ModalHeader} from "../../../Modal";
import ModalFooter from "../../../Modal/ModalFooter";
import Button from "../../../UI/Button";
import _axios from "../../../../httpService";
import {toast} from "react-toastify";
import {prefixUrl} from "../../../../utils/utilsData";
import Input from "../../../UI/Input";

function ModalOverlay(props) {

  const [titleOfTafsili, setTitleOfTafsili] = useState("")

  const addModalHandler = (code, value) => {

    const data = {
      request: "newAccount",
      data: {
        OUT_CHS: props.treeChartData.code,
        accountName: titleOfTafsili
      },
    }

    _axios
      .post(prefixUrl() + "/accountingAccounts/", data)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          props.setReload(Math.random());
          props.modalCallback({ isOpen: false });
        } else {
          toast.error(res.data.message);
        }
      });
  };

  return <>
    <Modal
      isOpen={props.isOpen}
      modalCallback={props.modalCallback}
    >
      <ModalHeader title={"افزودن تفصیلی جدید"}/>
      <ModalBody>
        <div className={"d-flex flex-wrap justify-content-center"}>
          <div className="input-side">
            <p>عنوان تفصیل : </p>
            <Input
              value={titleOfTafsili}
              onChange={(e) => {
                const v= e.target.value
                // console.log(v)
                setTitleOfTafsili(v)
              }}
              type={"text"}
            />
          </div>
        </div>


      </ModalBody>
      <ModalFooter>
        <Button
          color={"greenBtn"}
          onClick={addModalHandler}
          className={"px-5"}>
          تایید
        </Button>
      </ModalFooter>
    </Modal>
  </>
}

function AddTafsiliModal(props) {

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <ModalOverlay {...props}/>,
        document.getElementById('overlay-root')
      )}
    </React.Fragment>
  );
}

export default AddTafsiliModal;